import { combineReducers } from 'redux';
import createAnalyticsReducer from '../../common/reducers/analytics';
import { MELILLO_FORMS_ANALYTICS_REQUEST, MELILLO_FORMS_ANALYTICS_SUCCESS, MELILLO_FORMS_ANALYTICS_FAILURE } from './Melillo/actions';

const analytics = combineReducers({
	melillo: createAnalyticsReducer({
		types: [MELILLO_FORMS_ANALYTICS_REQUEST, MELILLO_FORMS_ANALYTICS_SUCCESS, MELILLO_FORMS_ANALYTICS_FAILURE],
		mapActionToKey: action => action.item
	})
});

export default analytics;